import { MainAppService } from "src/modules/app-template/services/main-app.service";

export enum CalendarEventKind {
    //netgen start
    appointment = 0,
    task = 1,
    milestone = 2
    //netgen end
}
export namespace CalendarEventKind{
    export function getName(value: CalendarEventKind): string {
        switch (value) {
            case CalendarEventKind.appointment:
                return "appointment";
            case CalendarEventKind.task:
                return "task";
            case CalendarEventKind.milestone:
                return "milestone";
            default:
                return "???";
        }
    }

    export function getDisplayName(value: CalendarEventKind, app: MainAppService): string {
        return app.t("entity.CalendarEventKind." + getName(value));
    }

    export function getDisplayShortName(value: CalendarEventKind, app: MainAppService): string {
        return app.t("entity.CalendarEventKind.short." + getName(value));
    }

    export function getStyleClass(value: CalendarEventKind): string {
        switch (value) {
            case CalendarEventKind.appointment:
                return "xbg-blue-200";
            case CalendarEventKind.task:
                return "xbg-orange-200";
            case CalendarEventKind.milestone:
                return "xbg-purple-200";
            default:
                return "???";
        }
    }
}
